/**
 * MEVYA Theme – globale Basisfunktionen.
 * Section-spezifisches Verhalten (Karussell, Zaehler, Akkordeon) liegt
 * als Custom Element direkt bei der jeweiligen Section.
 */

document.documentElement.classList.remove('no-js');

/* Lazy Loading Fallback fuer Bilder ohne natives loading="lazy" */
if ('loading' in HTMLImageElement.prototype === false) {
  const lazyImages = document.querySelectorAll('img[loading="lazy"]');
  const io = new IntersectionObserver((entries, observer) => {
    entries.forEach((entry) => {
      if (!entry.isIntersecting) return;
      const img = entry.target;
      if (img.dataset.src) img.src = img.dataset.src;
      observer.unobserve(img);
    });
  });
  lazyImages.forEach((img) => io.observe(img));
}

/* Fade-in sobald Bild geladen ist (verhindert Layout-Flackern) */
document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.lazy-image').forEach((img) => {
    if (img.complete) {
      img.classList.add('is-loaded');
    } else {
      img.addEventListener('load', () => img.classList.add('is-loaded'), { once: true });
    }
  });
});
